<template>
	<section class="blockElement position-relative between-footer fullchartIn-page p-0 whiteBG" id="FullChart">
		<div class="AdChart">

			<div class="split content split-horizontal second-wishlist position-relative  p-0" style="background-color: #rgb(234 250 240);height: 100%;width: 100%">{{create_liveCandle}}
			    <div class="loader homechartloader" v-if="loading == 1"></div>
			    <div class="stx-dialog-container">
			        <div id="studyDialogs" style="display:none;" class="stx-dialog" ref="studyDialogs">
			            <h4 class="title"></h4>
			            <div @click.prevent="dismissDialog()" class="stx-btn stx-ico"><span class="stx-ico-close"></span></div>
			            <div id="inputs">
			              	<div class="inputTemplate" style="display:none">
			    	            <div class="stx-heading"></div>
			    	            <div class="stx-data"></div>
			              	</div>
			            </div>
			            <div id="outputs">
			              	<hr/>
			              	<div class="outputTemplate" style="display:none">
			    	            <div class="stx-heading"></div>
			    	            <div class="stx-color"><span></span></div>
			              	</div>
			            </div>
			            <div id="parameters"></div>
			            <div @click.prevent="createStudy()" class="stx-btn">{{$t('adchart_create')}}</div>
			        </div>
			    </div>
			    <div class="insertTP position-relative d-flex align-items-center justify-content-between mb-2">
			    	<div class="leftArea-set d-flex align-items-center">
				    	<div class="inputSearch-field position-relative">
				    		<div class="position-relative">
					    		<input class="searchPopUp" type="text" placeholder="Enter Symbol" v-model="search" @focus="searchPopUp = true">
					    		<a class="search-btn" href="#"><feather type="search"></feather></a>
					    	</div>
					    	<div class="searchResult searchPopUp" v-if="searchPopUp && search != ''">
					    		<ul class="listSearch">
					    			<li v-for="spreads,key,index in user_isins" v-if="spreads.other.isinid.includes(search.toUpperCase())" @click.prevent="changeChart(spreads.other.mn,spreads.other.isinid)">
					    				<span class="id">{{spreads.other.isinid}}</span>
					    				<span class="bid" :class="[{'green': spreads.buy_increase_staus}, {'red': !spreads.buy_increase_staus}]">{{spreads.B}}</span>
					    				<span class="ask" :class="(spreads.B-spreads.other.closepx >= 0)?'green':'red'">{{spreads.other.closepx}}</span>
					    				<!-- <span class="ask" :class="(((spreads.B-spreads.other.closepx)/spreads.other.closepx)*100 >= 0)?'green':'red'">{{(((spreads.B-spreads.other.closepx)/spreads.other.closepx)*100).toFixed(3)}}%</span> -->
					    			</li>
					    		</ul>
					    	</div>
				    	</div>
				    </div>
			        <div class="favourite_sec d-flex align-items-center justify-content-between scrollbar">
			            <div class="graph_buysell_sec pull-left">
			                <!-- <h4>{{loadChart}}</h4> -->
			            </div>
			            <!--graph_buysell_sec-->

			            <div class="graph_option_sec d-flex align-items-center">
			                <div class="inLine-chart hideMobile">
			                    <button type="button" data-toggle="dropdown" class="appButton height-auto min-120 dropdown-toggle d-flex align-items-center"><feather size="13px" class="mr-2" type="upload-cloud"></feather>{{$t('adchart_save')}} </button>
			                    <div class="dropdown-menu">
			                        <a class="dropdown-item" href="#" @click.prevent="create_image()">{{$t('adchart_chart')}} </a>
			                        <!-- <a class="dropdown-item" href="#">Link 2</a>
			                        <a class="dropdown-item" href="#">Link 3</a> -->
			                    </div>
			                </div>
			                <div class="inLine-chart">
			                    <button type="button" data-toggle="dropdown" class="appButton height-auto dropdown-toggle">
			                        {{defaultChartInterval}}
			                    </button>
			                    <div class="dropdown-menu selectLine-chart">
			                        <a class="dropdown-item" :class="(defaultChartInterval == val.data)?'active':''" href="#" v-for="val in chartInterval" @click.prevent="changeInterval(val)">{{val.unit}} {{val.name}}</a>
			                    </div>
			                </div>
			                <div class="inLine-chart displayGrapph hideMobile">
			                    <button type="button" data-toggle="dropdown" class="appButton height-auto min-120 dropdown-toggle">
			                        {{ChartName(chartType)}}
			                    </button>
			                    <div class="dropdown-menu selectLine-chart">
			                        <a href="#" class="appButton dropdown-item d-flex align-items-center" :class="(chartType == chart.type)?'active':''" v-for="chart in chartTypelist" @click.prevent="changeChartType(chart.type)">
			                            <i class="add mr-1" :class="chart.class"></i>{{chart.value}}
			                        </a>
			                    </div>
			                </div>
			                <div class="inLine-chart displayGrapph Studies hideMobile">
			                    <button type="button" data-toggle="dropdown" class="appButton height-auto min-120 dropdown-toggle">
			                        {{$t('adchart_Studies')}}
			                    </button>
			                    <div class="dropdown-menu">
			                        <div class="search_share_sec d-flex align-items-center">
			                            <feather type="search"></feather>
			                            <input type="text" placeholder="Search for Studies" v-model="searchStudy" id="search_share" class="search_txtin" autocomplete="off"/>
			                        </div>
			                        <div class="scrollbar">
			                            <a class="dropdown-item" href="#" v-for="study in studiesAddedObjects">{{study.value}}<span @click.prevent="removeStudy(study.type)"><feather type="x"/></span></a>
			                            <!-- <a class="dropdown-item" href="#" v-for="study in studiesList" @click.prevent="addStudie(study.type)" v-if="!(studiesAddedList.includes(study.type))">{{study.value}}</a> -->
			                            <!-- <a class="dropdown-item" href="#" v-for="(study,name) in studies_List" @click.prevent="addStudie(study)">{{name}}</a> -->
			                            <a class="dropdown-item" href="#" v-for="(study,name) in studyListfunc" @click.prevent="addStudie(name)">{{study}}</a>
			                        </div>
			                    </div>
			                </div>
			                <!-- <div class="inLine-chart displayGrapph columns">
			                    <button type="button" data-toggle="dropdown" class="appButton d-flex align-items-center justify-content-between">
			                        <feather size="16px" type="columns"></feather>
			                    </button>
			                    <div class="dropdown-menu">
			                        <ul class="multi-chart-option">
			                            <li>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector"></i></a>
			                            </li>
			                            <li class="d-flex align-items-center">
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-1"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-2"></i></a>
			                            </li>
			                            <li class="d-flex align-items-center">
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-3"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-4"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-5"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-6"></i></a>
			                            </li>
			                            <li class="d-flex align-items-center">
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-7"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-8"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-9"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-10"></i></a>
			                            </li>
			                            <li class="d-flex align-items-center">
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-11"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-12"></i></a>
			                            </li>
			                            <li class="d-flex align-items-center">
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-13"></i></a>
			                                <a class="dropdown-item" href="#"><i class="add icon-vector-14"></i></a>
			                            </li>
			                        </ul>
			                    </div>
			                </div> -->
			                <!-- <div class="inLine-chart displayGrapph alertPad">
			                    <button type="button" class="appButton d-flex align-items-center justify-content-between">
			                        <feather size="16px" type="bell"></feather>
			                    </button>
			                </div> -->
			                <!-- <div class="inLine-chart displayGrapph settings">
			                    <button type="button" class="appButton d-flex align-items-center justify-content-between">
			                        <feather size="16px" type="settings"></feather>
			                    </button>
			                </div> -->
			                <div class="inLine-chart displayGrapph minimize">
			                    <button type="button" class="appButton d-flex align-items-center justify-content-between" @click.prevent="openFullscreen()">
			                        <feather size="16px" type="minimize"></feather>
			                    </button>
			                </div>
			                <!-- <div class="inLine-chart displayGrapph watch">
			                    <button type="button" class="appButton d-flex align-items-center justify-content-between">
			                        <feather size="16px" type="eye"></feather>
			                    </button>
			                </div> -->
			                <!--Alert-Pop-->
			            </div>
			        </div>
			    </div>
			    <div class="chartRatio position-relative" controls>
			        <div class="d-flex border-top calHight">
			            <div class="leftNva-inchart scrollbar">
			                <ul>
			                    <li v-for="item in 10">
			                        <a href="#"><i :class="'icon-list'+item"></i></a>
			                    </li>
			                </ul>
			            </div>
			            <div class="chartMap advancedChartContainer"  style="height:calc(100vh - 308px); top: 0 ;width: 100%;overflow: hidden;">
			                <div class="bysellGraph" style="z-index: 19;top: 48px !important;" v-if="ChartValues.Open">
				                <p><!-- <span>{{instruments[loadChart].m}}</span> --><span class="green"> O:</span> {{ChartValues.Open}} <span class="green">H:</span> {{ChartValues.High}} <span class="red">L:</span> {{ChartValues.Low}} <span class="red">C:</span> {{ChartValues.Close}} </p>
				            </div>

				            <div class="dataFailed d-flex align-items-center justify-content-center h-100 w-100" v-else-if="loading == 0 && stxDataListLength <= 1">
				            	<div class="loadMessage w-100 text-center">
					            	<p class="mb-0">{{$t('adchart_failedchart')}}</p>
					            	<p class="mb-0">{{$t('adchart_kindlyrefresh')}}</p>
					            </div>
				            </div>
			            </div>
			        </div>
			        <div class="charTab bottomInc d-flex justify-content-between  scrollbar">
			            <div class="leftMotnh d-flex align-items-center">
			                <!-- <a class="d-flex align-items-center justify-content-center arrowDown" href="#"><feather size="18px" type="chevron-down"></feather> </a>
			                <p class="d-flex align-items-center m-0">
			                    <a class="white" @click.prevent="" href="#"><span>1d</span></a>
			                    <a class="white" @click.prevent="" href="#"><span>5d</span></a>
			                    <a class="white" @click.prevent="" href="#"><span>1m</span></a>
			                    <a class="white" @click.prevent="" href="#"><span>3m</span></a>
			                    <a class="white" @click.prevent="" href="#"><span>6m</span></a>
			                    <a class="white" @click.prevent="" href="#"><span>1y</span></a>
			                    <a class="white" @click.prevent="" href="#"><span>5 Year</span></a>
			                    <a class="white" @click.prevent="" href="#"><span>Max</span></a>
			                </p> -->
			            </div>
			            <!-- <div class="rightTbs" v-if="$route.name != 'scrip-detail'">
			                <ul class="d-flex align-items-center">
			                    <li :class="(loadChart == 'BTC-USD')?'active':' '">
			                        <a @click.prevent="changeChart('BTC-USD')" href="#">BTC-USD</a>
			                    </li>
			                    <li :class="(loadChart == 'BTC-USDT')?'active':' '">
			                        <a @click.prevent="changeChart('BTC-USDT')" href="#">BTC-USDT</a>
			                    </li>
			                    <li :class="(loadChart == 'ETH-BTC')?'active':' '">
			                        <a @click.prevent="changeChart('ETH-BTC')" href="#">ETH-BTC</a>
			                    </li>
			                    <li :class="(loadChart == 'LTC-BTC')?'active':' '">
			                        <a @click.prevent="changeChart('LTC-BTC')" href="#">LTC-BTC</a>
			                    </li>
			                </ul>
			            </div> -->
			        </div>
			    </div>
			</div>
		</div>
	</section>
</template>
<script>
// import { Const } from '@/plugins/vue-provider-cache/const.mod'
var Stx = require('../../../../static/fxView/js/stx.js')
export default {
    name: 'Chart-page',
    data() {
        return {
			loading: 1,
			stxx : "",
            "loadChart" : "EURUSD",
            intervalPeriod: 60,
            chartInterval: [
               {'unit':1,'name':'minute',data:'1m'},
               {'unit':1,'name':'hour',data:'1h'},
               {'unit':1,'name':'day',data:'1day'},
               {'unit':1,'name':'week',data:'1week'},
               {'unit':1,'name':'month',data:'1month'}
            ],
            defaultChartInterval: '1day',
            searchPopUp:false,
            search:'',
            ShowSearchPopup:false,
            ChartValues:{Open:'',High:'',Low:'',Close:''},
            chartType:'mountain',
            chartTypelist:[
                {type:'candle', value:'Candle', class:'icon-candle'},
                {type:'hollow_candle', value:'Hollow Candle', class:'hollow-candle'},
                {type:'colored_line', value:'Line', class:'icon-line'},
                {type:'colored_bar', value:'Bar', class:'icon-bar'},
                {type:'histogram', value:'Histogram', class:''},
                {type:'baseline_delta_mountain', value:'Baseline Mountain', class:'icon-baseLine'},
                {type:'mountain', value:'Mountain', class:'icon-baseLine'},
                // {type:'wave', value:'Wave', class:''}
            ],
            searchStudy:'',
            studiesAddedObjects:[],
            studiesAddedList:[],
            studies_List:{},
		}
    },
    methods:{
    	viewVal(spreads){
    		//console.log(spreads)
    	},
    	create_image(){
    		var stx = this.stxx
		    var link = document.createElement('a');
		  	link.download = this.loadChart+'-Chart.jpeg';
			// var ctx = canvas.getContext("2d");
			// ctx.fillStyle = "blue";
			// ctx.fillRect(0, 0, canvas.width, canvas.height);
		  	link.href = stx.chart.canvas.toDataURL("image/png")
		  	link.click();
    	},
        dismissDialog(){
            Stx.STX.DialogManager.dismissDialog()
        },
    	createStudy(){
            const div = this.$refs.studyDialogs
			var a = Stx.STX.Studies.go(div, this.stxx);
            for(var type in a){
            	for(var std in a[type]){
            		_.CIQ.Studies.studyLibrary[div.study][type][std] = a[type][std]
            	}
            }
            _.CIQ.Studies.addStudy(this.stxx, div.study)
			Stx.STX.DialogManager.dismissDialog()
		},
        addStudie(studie){
        	//console.log(studie)
            var _that =  this
            var study = studie
            if(!_that.stxx || !_that.stxx.chart.dataSet) return;
            if(_.CIQ.Studies.studyLibrary[study] && _.CIQ.Studies.studyLibrary[study].name){
            	//console.log(1,studie,_that.stxx.translateIf(_.CIQ.Studies.studyLibrary[study].name),window._.$$("studyDialogs").querySelectorAll(".title")[0])
            	window._.$$("studyDialogs").querySelectorAll(".title")[0].innerHTML=_that.stxx.translateIf(_.CIQ.Studies.studyLibrary[study].name);
            }else {
            	//console.log(2,studie)
            	window._.$$("studyDialogs").querySelectorAll(".title")[0].innerHTML=study.capitalize();
            }
            //console.log('prev',studie,window._.$$("studyDialogs"))
            Stx.STX.Studies.studyDialog(_that.stxx, study, window._.$$("studyDialogs"));
            //console.log('next',studie)
            var delay=Stx.STX.ipad?400:0;  // so that ipad doesn't register taps from menu selection on dialog
            setTimeout(function(){
            	//console.log('abc',Stx.STX.DialogManager)
            	//console.log('abc1',document.getElementById('studyDialogs'))
                Stx.STX.DialogManager.displayDialog("studyDialogs");
            	//console.log('abc2',document.getElementById('studyDialogs'))
            }, delay);
            //console.log(1,studie,_that.stxx.translateIf(_.CIQ.Studies.studyLibrary[study].name),window._.$$("studyDialogs").querySelectorAll(".title")[0],window._.$$("studyDialogs"))
        },
        removeStudy(val){
        	var study;
        	for (var studyInstanceName in this.stxx.layout.studies) {
				var sd = this.stxx.layout.studies[studyInstanceName];
				if(sd.type == val){
					study = sd
				}
			}
			if(study){
				_.CIQ.Studies.removeStudy(this.stxx, study)
			}
        	this.studiesAddedObjects = this.studiesAddedObjects.filter(data => data.type != val)
        	this.studiesAddedList = this.studiesAddedList.filter(data => data != val)
        },
        ChartName(chartType){
            return this.chartTypelist.filter(val=>val.type == chartType)[0].value
        },
        changeChartType(type){
            this.chartType = type
            this.stxx.setChartType(type)
        },
        openFullscreen() {
            if(document.fullscreenElement){
                document.exitFullscreen();
            }else{
                var elem = document.body;
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.webkitRequestFullscreen) { /* Safari */
                    elem.webkitRequestFullscreen();
                } else if (elem.msRequestFullscreen) { /* IE11 */
                    elem.msRequestFullscreen();
                }
            }
        },
        drop(ev){
            var data = ev.dataTransfer.getData("text");
            // console.log(data)
            this.changeChart(data)
        },
        dataList(value){
            var data = Object.values(value)
            try{
                if(data.length > 0 ){
                    var _that = this
                    if(this.search != ''){
                        return data.filter( (val) => {
                            return val.other.isinid.toLowerCase().includes(_that.search.toLowerCase()) 
                        })
                    }
                    else{
                        return data
                    }
                }else { return []}
            }catch(e){
               return [] 
            }
        },
        stxDataListLength(){
        	try{
                return this.stxx.chart.dataSet.length
            } catch(e){ return 0}
        },
   		changeChart(marketName,marketName1){           
            try{
                const _her = this
                _her.loading = 1

                this.loadChart = marketName1
                this.search = ''
                _her.stxx.chart.symbolDisplay= marketName1;
                this.stxx.newChart(marketName, null, null, function () {
                    _her.loading = 0
                    _her.stxx.chart.symbolDisplay= marketName1;
                });
            } catch(e){              
                // console.log(e)
            }            
        },
		changeInterval: function(value){
			this.defaultChartInterval = value.data;
			var intval = value.unit
			var tUnit = value.name
			if(tUnit == "hour"){
				intval = intval*80;
				tUnit = "minute";
			}
			this.stxx.setPeriodicity({period:1, interval:intval, timeUnit:tUnit});
		},
		initalizeChart: function(){
			this.stxx = new window._.CIQ.ChartEngine( {
				   container: window._.$$$(".advancedChartContainer"), 
				   allowScrollFuture: false, 
				   allowScrollPast: false, 
				   layout:{"candleWidth": 10, "crosshair":true, allowScrollFuture: false, allowScrollPast: false}
				}
			);
			if(this.stxx.controls.chartControls){
				// stxx.controls.chartControls.style.display="block";        // use this line to enable the controls
				this.stxx.controls.chartControls.style.display="none";        // use this line to disable the controls
			}
			this.stxx.chart.xAxis.displayGridLines=true;
			this.stxx.chart.yAxis.displayGridLines=true;
			this.stxx.setStyle("stx_grid","color", 'rgb(0 0 0 / 5%');
			this.stxx.setStyle("stx_grid_dark","color", 'rgb(0 0 0 / 5%');

			this.stxx.setChartType('mountain');
			this.stxx.setStyle("stx_mountain_chart","background-color", '#0bb783'); 
			this.stxx.setStyle("stx_mountain_chart","border-top-color", '#25c16f'); 

			this.stxx.setStyle("stx_candle_up","color", '#25c16f');                
			this.stxx.setStyle("stx_candle_up","border-left-color", '#66000000');                
			this.stxx.setStyle("stx_candle_down","color", '#e03338');
			this.stxx.setStyle("stx_candle_down","border-left-color", '#66000000');
			this.stxx.setStyle("stx_candle_shadow_up","color", '#25c16f');                
			this.stxx.setStyle("stx_candle_shadow_down","color", '#e03338');

			this.stxx.setStyle("stx_xaxis_dark","color", '#404b51'); 
			this.stxx.setStyle("stx_xaxis","color", '#404b51'); 
			this.stxx.setStyle("stx_yaxis_dark","color", '#404b51'); 
			this.stxx.setStyle("stx_yaxis","color", '#404b51'); 
			this.stxx.setStyle("stx-panel-control","color", '#404b51'); 

			this.stxx.chart.xAxis.axisType="ntb";
			this.stxx.chart.yAxis.goldenRatioYAxis=true;
            // this.stxx.yaxisLeft = 0;
            this.stxx.chart.yAxis.justifyRight = true;
			this.stxx.chart.yAxis.position="right";
			this.stxx.allowEquations = false;
			this.stxx.attachQuoteFeed(__.quoteFeedSimulator,{refreshInterval:this.intervalPeriod,bufferSize:60});
			this.stxx.setMarketFactory(window._.CIQ.Market.Symbology.factory);

			this.stxx.chart.symbolDisplay= this.loadChart;
			// this.stxx.chart.yAxis.initialMarginTop=60;
			//this.stxx.cleanupGaps = "carry";
			// this.stxx.setPeriodicity({period:1, interval:1, timeUnit:"minute"});
			this.stxx.setPeriodicity({period:1, interval:1, timeUnit:"day"});
			const _her = this
			this.stxx.newChart(this.loadChart, null, null, function () {
				_.CIQ.Drawing.prototype.dragToDraw=true;
				_her.loading = 0
			});
			this.stxx.setMaxTicks(120);
            // _.CIQ.Studies.addStudy(this.stxx, "vol undr");
			this.stxx.setCandleWidth(this.stxx.layout.candleWidth*1.1);
			this.stxx.draw();
            this.stxx.chart.allowScrollFuture = false;

		},
        setChartValues(open,high,low,close){
            this.ChartValues.Open = open ;
            this.ChartValues.High = high;
            this.ChartValues.Low = low;
            this.ChartValues.Close = close;
        },
    },
   	computed: {
   		user_isins() {
          try {
            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.currencyAll()
          } catch (ex) {
            return {}
          }
        },
        studyListfunc(){
            try{
                var _that = this
                var a={},b=Object.keys(window._.CIQ.Studies.studyLibrary).sort()
                b.forEach(key=>{
                    if( _that.searchStudy != '' ){
                        if(key.toLowerCase().includes(_that.searchStudy.toLowerCase())){
                            a[key] = _.CIQ.Studies.studyLibrary[key].name
                        }
                    }else{
                        a[key] = _.CIQ.Studies.studyLibrary[key].name
                    }
                })
                return a
            }catch(e){ return {} }
        },
	   	create_liveCandle(){
	        try{
	            if(this.loadChart!= ''){
	                let newQuotes = {}
	                var d = new Date() // DT is a string in ISO format, make it a Date instance
	                var getYear = d.getFullYear()
	                var getDate = d.getDate()
	                var getMonth = d.getMonth()+1
	                var getHours = d.getHours()
	                var getMins = d.getMinutes()

	                if(getMonth <= 9){ getMonth = "0"+getMonth; }
	                if(getDate <= 9){ getDate = "0"+getDate; }
	                if(getHours.toString().length <= 1){ getHours = "0"+getHours; }
	                if(getMins.toString().length <= 1){ getMins = "0"+getMins; }

	                if(this.defaultChartInterval == "1day" || this.defaultChartInterval == "1week" || this.defaultChartInterval == "1month"){
	                    newQuotes.DT = getYear+"-"+getMonth+"-"+getDate+" "+"00:00:00"
	                }else{
	                    newQuotes.DT = getYear+"-"+getMonth+"-"+getDate+" "+getHours+":"+getMins+":00";
	                }
	                let LTP   = this.instruments[this.loadChart].B

	                let open  = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Close                    
	                let high  = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].High
	                let low    = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Low
	                let Volume    = this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Volume                    
	                let close =  this.instruments[this.loadChart].B

                    this.setChartValues(this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Open,high,low,this.stxx.chart.dataSet[this.stxx.chart.dataSet.length-1].Close)
	                if(low != 0 && low != NaN){                                    
	                    if(LTP > high){ high= LTP; }
	                    if(LTP < low){ low= LTP; }
                        this.setChartValues(open,high,low,close);                    
	                    newQuotes.Open=parseFloat(open);
	                    newQuotes.High=parseFloat(high);
	                    newQuotes.Low=parseFloat(low);
	                    newQuotes.Close=parseFloat(close);
	                    newQuotes.Volume=parseFloat(0);                        
	                    this.stxx.appendMasterData(newQuotes, null, {fillGaps: true});
	                }
	            }                    
	        }catch(ex){ }
	    },
	   	instruments() {
    	    try {                    
	            this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
	            return this.$store.getters[Const.GET_PROVIDERS]['priceFeed'].iCache.asKeysValueArrayAll()
	        } catch (ex) {                
	            return []
	        }
	    },
        // get_currencies(){
        //     try {
        //         this.$store.getters[Const.GET_HEARTBEATS]['priceFeed']
        //         return this.$store.getters[Const.GET_PROVIDERS]['priceFeed']
        //         .iCache.asKeysValueArrayAll()
        //     } catch (ex) {
        //         return []
        //     }
        // }
   	},
	created(){
		/*if(this.$route.query.market){
			this.loadChart = this.$route.query.market
		}*/
		const _that = this
		setTimeout(function(){ _that.initalizeChart() }, 1000);
	},
    mounted() {
        const _that = this
        $(document).on("click", function(event){
            if(!$(event.target).closest('.searchPopUp').length){
                _that.searchPopUp = false
            }
        });
        document.body.addEventListener('fullscreenchange', (event) => {
            if (document.fullscreenElement) {
                event.target.classList.add("fullScreen-map")
            } else {
                event.target.classList.remove("fullScreen-map")
            }
        });
    }	
}
</script>
<style >
   @import "../../../../static/fxView/css/stx-standard.css"
   /*@import "../../../../static/fxView/css/stx-chart.css"*/
   
</style>



// WEBPACK FOOTER //
// src/components/fxView/shared/advanced-chart.vue